import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  wrapper: {
    width: ({ isNavbarOpen }) => `calc(100% - ${isNavbarOpen ? "22rem" : "12rem"})`,
    height: "80vh",
    backgroundColor: "#fff",
    marginTop: "-2rem",
    marginLeft: ({ isNavbarOpen }) => (isNavbarOpen ? "22rem" : "12rem"),
    boxShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.2)",
    borderRadius: "10px",
    marginBottom: "10px",
    
    "@media (max-width: 599px)": {
      width: ({ isNavbarOpen }) =>
        `calc(100% - ${isNavbarOpen ? "44%" : "38%"})`,
    },
    "@media (min-width: 600px) and (max-width: 899px)": {
      width: ({ isNavbarOpen }) =>
        `calc(100% - ${isNavbarOpen ? "38%" : "35%"})`,
    },
    "@media (min-width: 900px) and (max-width: 1199px)": {
      width: ({ isNavbarOpen }) =>
        `calc(100% - ${isNavbarOpen ? "20%" : "12%"})`,
      marginLeft: ({ isNavbarOpen }) => (isNavbarOpen ? "18rem" : "12rem"),
    },
  },
  iframeWrapper: {
    backgroundColor: "#fff",
    borderBottomRightRadius: "10px",
    borderBottomLeftRadius: "10px",
  },
  iframe: {
    width: "100%",
    padding: ({ isSmartRepairExpanded }) =>
      isSmartRepairExpanded ? "0px" : "10px",
    paddingTop: "3px",
    height: ({ isSmartRepairExpanded }) =>
      isSmartRepairExpanded ? "100vh" : "calc(85vh - 60px)",
    border: "none",
  },
  backBtn: {
    marginRight: "2%",
    backgroundColor: "#8588A1",
    fontWeight: 700,
    fontSize: "12px",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#8588A1",
    },
  },
  btnContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  backIcon: {
    marginBottom: "1px",
  },
  expandIcon: {
    backgroundColor: "#8588A1",
    "&:hover": {
      backgroundColor: "#8588A1",
    },
    color: "#fff",
    width: "30px",
    height: "35px",
  },
  titleWrapper: {
    display: "flex",
    width: "80%",
    alignItems: "center",
    textAlign: "left",
  },
  title: {
    fontSize: "1.2rem",
    fontFamily: 'Rubik',
    marginTop: 5,
    marginLeft: "0.7rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
  },
  headerGrid: {
    paddingRight: "1%",
    paddingLeft: "1.5%",
    paddingTop: "12px",
    paddingBottom: "5px",
    marginTop: "2rem",
  },
});